export default __webpack_public_path__ + "static/media/hs1.0bf0d4ae.png";